import { Component, Input } from '@angular/core';
import { Customer } from "./customer";
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { Subscription } from "rxjs/Subscription";
import { LocalStorageService } from "angular-2-local-storage";
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { SearchTableState } from "../search-table-state";
import { Column } from "../column";
import { AlertService } from "../../../services";
import { PageStateService } from "../page-state.service";
import { UserManagementService } from "../user/user-management.service";
import { CustomerManagementService } from "./customer-management.service";
import { BaseTableComponent } from "../base-table.component";
import { ProgrammeService } from "../../../services/DataServices/programme.service";
import { LoyaltySite } from "../loyalty-site/loyalty-site";


import * as FileSaver from "file-saver";
import { PermissionService } from "../../../services/SecurityServices/permission.service";

@Component({
    template: require('./customer-management-table.html'),
    providers: [UserManagementService, CustomerManagementService, LocalStorageService],
    styles: [require('../table.css')]
})

export class CustomerManagementTableComponent extends BaseTableComponent {


    private customers = new Array<Customer>();
    private allLoyaltySites: Array<LoyaltySite> = [];
    private searchTableState: SearchTableState;
    private loyaltySite: LoyaltySite = null;
    private columns: Array<Column>;
    private busy: Subscription;
    private queryParamsSub: any;
    private displayFilter: boolean = true;
    private buttonDisabled: boolean = true;
    private showFilter: boolean = true;
    private static lastRefreshed: string = 'customer-last-refreshed';
    private disableCustomers: boolean = false;
    private disableExportToExcel: boolean = false;
    private disableViewCustomer: boolean = false;
    private disablePostCustomer: boolean = false;
    private disableCustomerMerge: boolean = false;
    private dateFormat: string = 'yyyy-mm-dd';
    private datePickerOptions: IMyDpOptions = {
        height: '30px',
        dateFormat: this.dateFormat
    };

    constructor(
        private userManagementService: UserManagementService,
        private customerManagementService: CustomerManagementService,
        private router: Router,
        private route: ActivatedRoute,
        private alertService: AlertService,
        private pageStateService: PageStateService,
        private localStorageService: LocalStorageService,
        private programmeService: ProgrammeService,
        private permissionService: PermissionService
    ) {
        super(localStorageService, customerManagementService.searchTableState);
        this.setColumns();
    }

    public goTo(value: number): void {
        if (value <= this.searchTableState.pageCount()) {
            this.searchTableState.pageChange(value);
            this.updateTable();
        }
    }

    ngOnInit() {
        if (this.allLoyaltySites.length == 0) {
            this.programmeService.getLoyaltySites().subscribe(data => this.allLoyaltySites = data);
        }
    }

    ngAfterContentInit() {
        this.setPermissions();
        this.searchTableState = this.customerManagementService.searchTableState;
        this.searchTableState.currentPage = this.pageStateService.currentCustomerPage;
        this.setPageSize('customer-page-size');
        this.setLastRefreshed(CustomerManagementTableComponent.lastRefreshed);
        let self: CustomerManagementTableComponent = this;
        this.queryParamsSub = this.route.paramMap.subscribe((params: ParamMap) => {
            self.searchTableState.permissionsValue = 32;
        });
        if (!this.route.snapshot.url.join('/').includes("customer-management")) {
            self.displayFilter = false;
            self.showFilter = false;
        }
    }

    ngOnDestroy() {
        this.pageStateService.currentCustomerPage = this.searchTableState.currentPage;
        this.queryParamsSub.unsubscribe();
    }



    private setPermissions(): void {
        let self: CustomerManagementTableComponent = this;
        let hasPermission: boolean = this.permissionService.userHasPermission('Customers_SetBulkUserStatus');
        if (hasPermission) {
            this.disableCustomers = !hasPermission;
            return;
        } else {
            this.disableCustomers = !this.permissionService.userHasPermission('Customers_SetUserStatus');
        }
        this.disableViewCustomer = !this.permissionService.userHasPermission('View_Customer');
        this.disablePostCustomer = !this.permissionService.userHasPermission('Customers_PostUser');
        this.disableExportToExcel = !this.permissionService.userHasPermission('Customers_ExportExcel');
        this.disableCustomerMerge = !this.permissionService.userHasPermission('View_Customer_Merge');
    }

    private setColumns() {
        this.columns = new Array<Column>();
        this.columns.push(new Column('Mobile Number', 'MobileNumber'));
        this.columns.push(new Column('Email', 'Email'));
        this.columns.push(new Column('First Name', 'FirstName'));
        this.columns.push(new Column('Surname', 'Surname'));
        this.columns.push(new Column('Membership Number', 'ExternalId'));
        this.columns.push(new Column('Date Created', 'CreatedDateUtc'));
        this.columns.push(new Column('', ''))
        this.columns.push(new Column('Status', 'StatusId'));
    }

    private blankPage() {
        this.customers = new Array<Customer>();
        for (let i: number = 0; i < this.searchTableState.itemsPerPage; i++) {
            this.customers.push(new Customer());
        }
    }

    private disableCustomer(e: boolean, customer: Customer) {
        customer.statusId = e;
        var newStat = !customer.statusId;
        let self: CustomerManagementTableComponent = this;
        this.busy = this.userManagementService.setBulkUserStatus([customer.userId], newStat).subscribe(() => {   
        }, error => {customer.statusId = false; newStat = false;});
        customer.statusId = newStat;
    }

    private exportExcel(): void {
        if (this.searchTableState.updating) {
            return;
        }
        this.searchTableState.updating = true;
        let self: CustomerManagementTableComponent = this;
        this.userManagementService.searchTableState = self.searchTableState;
        this.userManagementService.exportExcel().subscribe(blob => {
            self.searchTableState.updating = false;
            if (!blob) {
                return;
            }
            var fileName = 'Customers_' + this.searchTableState.lastRefreshed + '.xlsx';
            self.searchTableState.updating = false;
            FileSaver.saveAs(blob, fileName);
            self.alertService.success('File generated successfully.');

        }, error => self.searchTableState.updating = false);
    }

    private filterTable(): void {
        if (this.searchTableState.fromDate && this.searchTableState.toDate && this.searchTableState.fromDate.getTime() > this.searchTableState.toDate.getTime()) {
            this.alertService.error('From Date cannot be more than To Date');
            return;
        }
        this.updateTable();
    }

    private updateTable(): void {
        if (this.searchTableState.updating) {
            return;
        }
        this.searchTableState.updating = true;
        if (this.loyaltySite !== null) {
            this.searchTableState.loyaltySiteId = this.loyaltySite.LoyaltySiteId;
        }
        let self: CustomerManagementTableComponent = this;
        this.busy = this.customerManagementService.search().subscribe((message: Array<Customer>) => {
            self.searchTableState.updating = false;
            self.customers = message;
        }, error => self.searchTableState.updating = false);
    }

    private onClick(customer: Customer): void {
        if (!this.disableViewCustomer) {
            this.router.navigate(['admin/customer-management/customer', customer ? customer.userId : 'new']);
        }
    }

    private customerMerge(): void {
        this.router.navigate(['admin/customer-management/customer-merge']);
    }

    private refreshTable() {
        if (this.searchTableState.updating) {
            return;
        }
        this.updateLastRefreshed(CustomerManagementTableComponent.lastRefreshed);
        this.updateTable();
    }

    private loyaltySiteListFormatter(data: LoyaltySite): string {
        return data.SiteName;
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/customer/customer-management-table.component.ts